import { render, staticRenderFns } from "./ItemDialogMedia.vue?vue&type=template&id=5cf7ef32&scoped=true&"
import script from "./ItemDialogMedia.vue?vue&type=script&lang=js&"
export * from "./ItemDialogMedia.vue?vue&type=script&lang=js&"
import style0 from "./ItemDialogMedia.vue?vue&type=style&index=0&id=5cf7ef32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7ef32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems})
